export default "__VITE_ASSET__B8s5ZKGx__"